<template>
    <section class="select-a-dealer" id="selectADealer">
        <div class="select-a-dealer__container container">
            <StepBar />

            <StepLink :step="2" />

            <div class="select-a-dealer__columns">
                <div class="select-a-dealer__search-box">
                    <h3 class="select-a-dealer__search-box-title">Search for your dealer</h3>
                    <DealerLookup :inputNullable="true" placeholder="Search by postcode" @postcodeSearch="updatePostcodeSearch" @place-updated="handlePlaceUpdate" />
                </div>

                <template v-if="postcodeSearch == 1">
                    <div is="transition-group" name="fade" class="select-a-dealer__dealer-card-grid">
                        <div class="card select-a-dealer__card" v-for="dealer in closestDealers" :key="dealer.id">
                            <div class="card__inner select-dealer-card">
                                <div class="select-dealer-card__address">
                                    <h3 class="select-dealer-card__title">Dealer Address</h3>
                                    <p class="select-dealer-card__info">
                                        {{ dealer.name }} <br />
                                        {{ dealer.address }} <br />
                                        {{ dealer.postcode }}
                                    </p>
                                </div>

                                <div class="select-dealer-card__logo">
                                    <picture v-if="dealer.brand == 'abarth' || dealer.brand == 'alfa-romeo'">
                                        <source type="image/webp" :srcset="`/img/logos/borderless/${dealer.brand}.webp, /img/logos/borderless/${dealer.brand}@2x.webp 2x`">
                                        <img class="img-responsive" :src="`/img/logos/borderless/${dealer.brand}.jpg, /img/logos/borderless/${dealer.brand}@2x.jpg 2x`" :alt="dealer.brand">
                                    </picture>
                                    <img v-else class="img-responsive" :src="`/img/logos/borderless/${dealer.brand}.svg`" :alt="dealer.brand" />
                                </div>

                                <button type="button" class="btn btn--primary-inverted select-dealer-card__cta" @click="selectDealer(dealer)">
                                    Select this dealer
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="load-more__container">
                        <a @click.prevent="incrementDealersToShow" v-if="showLoadMoreLink" class="load-more__link">Load more ...</a>
                    </div>
                </template>
                <div v-else>
                    <div class="select-a-dealer__help-container">
                        <img src="/images/info.svg" alt="" class="select-a-dealer__help-icon" />
                        <p class="select-a-dealer__help-text">Enter your town/postcode above and choose your address from the list in order to find your nearest dealership</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { StepBar, StepLink } from "../";
import DealerLookup from "../DealerLookup";
import EventObject from '../../../modules/tracking/EventObject';

export default {
    components: {
        DealerLookup,
        StepBar,
        StepLink,
    },

    data() {
        return {
            dealersToShow: 3,
            postcodeSearch: 0,
        };
    },

    computed: {
        ...mapState("OSB", ["brand", "selectedVehicle", "registration", "mileage"]),
        ...mapState("Dealers", ["dealers", "selectedDealer"]),

        filteredDealers() {
            if (this.brand !== "") {
                return this.dealers.filter((dealer) => {
                    return dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === this.brand.toLowerCase();
                });
            }

            return this.dealers.filter((dealer) => {
                return dealer.offers_servicing === "Y" && dealer.brand.toLowerCase() === window.brand.toLowerCase();
            });
        },

        closestDealers() {
            return this.filteredDealers.slice(0, this.dealersToShow);
        },

        showLoadMoreLink() {
            return this.closestDealers.length < this.filteredDealers.length;
        },
    },

    methods: {
        ...mapMutations("Dealers", ["setSelectedDealer"]),
        ...mapMutations("OSB", ["incrementStep"]),

        selectDealer(dealer) {
            new EventObject('OSB', 'Click', 'Select this dealer clicked').dispatch();
            this.setSelectedDealer(dealer);
            this.$emit('collect-pricing');
            this.next_step();
        },

        incrementDealersToShow() {
            this.dealersToShow += 3;
        },

        scrollToTop() {
            window.scrollTo(0, 0);
        },

        next_step() {
            this.incrementStep();
            this.scrollToTop();
        },

        updatePostcodeSearch(value) {
            this.postcodeSearch = value;
        },

        handlePlaceUpdate(place) {
            this.$emit('place-updated', place);
        }
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/online-service-booking/components/Steps/SelectADealer.vue